module.exports = __webpack_public_path__ + "img/browser_abp-2.55badeee.png";